"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
var components_1 = require("../../components");
var box_styles_css_1 = __importDefault(require("./box.styles.css"));
var Box = /** @class */ (function () {
    function Box() {
        var optionalProps = components_1.options.getProps();
        var theme = optionalProps.theme && optionalProps.theme.box ? optionalProps.theme.box : box_styles_css_1.default.box;
        this.ref = null;
        this.render(theme);
    }
    Box.createMarkup = function (theme) {
        var el = document.createElement('div');
        el.classList.add(theme);
        return el;
    };
    Box.prototype.render = function (theme) {
        var markup = Box.createMarkup(theme);
        this.ref = markup;
        return markup;
    };
    return Box;
}());
exports.Box = Box;
